<template>
  <div>
    <div style="display: flex; margin-bottom: 20px; margin-left: 40px">
      <el-page-header
        @back="back"
        content="打印出库单"
        style="margin-right: 20px"
      ></el-page-header>
      <button type="primary" @click="printContext">打印</button>
    </div>
    <div id="printMe"  ref="print">
      <div class="printtable" style="page-break-after:always;">
        <div class="table_title">{{ATableData.organizationName}} (出库单)</div>
      <!-- 打印 -->
      <div>
        <div class="AMarkUl">
          <ul>
            <li>出库单号:{{ ATableData.outstockNo }}</li>
            <li>一级货主:{{ ATableData.primaryCustomerName }}</li>
            <li>二级货主:{{ ATableData.customerName }}</li>
          </ul>
          <ul>
            <li>车牌号:{{ ATableData.outstockPlateNumber }}</li>
            <li>司机:{{ ATableData.driverName }}</li>
            <li>司机电话:{{ ATableData.telephone }}</li>
            <!-- <li>货物类型:{{ ATableData.productTypeName }}</li> -->
          </ul>
        </div>
        <table style="word-break:break-all;word-wrap:break-all;">
          <tbody>
            <tr>
              <td class="kunbao" style="min-width:75px">货物类型</td>
              <td class="kunbao" style="">产地</td>
              <td class="kunbao">规格</td>
              <td class="kunbao">材质</td>
              <!-- <td class="kunbao">长度(m)</td> -->
              <td class="kunbao">件数</td>
              <td class="kunbao">重量(吨)</td>
              <td class="kunbao">过磅净重（吨）</td>
            </tr>
            <tr v-for="(item, index) in ATableList" :key="index">
              <td class="">{{ item.productTypeName }}</td>
              <td class="">{{ item.placeOfOrigin }}</td>
              <td class="">{{ item.specification }}</td>
              <td class="">{{ item.model }}</td>
              <!-- <td class="">{{ item.length }}</td> -->
              <td class="">{{ item.number }}</td>
              <td class="">{{ Number(item.allWeight).toFixed(3) }}</td>
              <td class="">{{ Number(item.weighingWeight).toFixed(3) }}</td>
            </tr>
            <tr>
              <td>合计</td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{numberSum}}</td>
              <td>{{weightSum}}</td>
              <td>{{GBweight}}</td>
            </tr>
             <tr>
              <td>备注</td>
              <td colspan='6' style="text-align:left">{{ATableData.remark}}</td>
            </tr>
          </tbody>
        </table>
        <div class="AMarkFoot">
          <ul>
            <li>开票员:{{ ATableData.outstockUserName }}</li>
            <li>打印人：{{username }}</li>
            <li>司机签名：</li>
            <li>打印日期:{{ datenow }}</li>
          </ul>
        </div>
        <div class="remarks" v-if="jfFlag==1">

        </div>
        <div class="remarks" v-else>
          提示：1、开票员认真核对出库单与实际出库货物是否一致。2、验放人员必须认真核对车上所装货物是否正确无误。3、出库前司机必须点清货物，出库后如有问题本库概不负责。4、货物在未出库前货物上现有的牌禁止摘掉。5、出库单不能涂改，如有涂改必须有本库盖章方可有效。联系电话： 15901312895  13501123680 010-69773715
        </div>
      </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  printOutstockDocumentLwg
} from '@/api/wms-access'
import DonMessage from '@/utils/message'
import { dateFormat1 } from '@/utils/util'
import { getDictionaryList } from '@/api/wms-stock'

export default {
  data () {
    return {
      weightSum: 0,
      numberSum: 0,
      GBweight: 0,
      totalNum: 0,
      totalWeightDouble: 0,
      id: '',
      idAll: '',
      type: 0,
      getData: null,
      flag: 0,
      getFlag: false,
      ATableList: [], // 表格
      ATableData: [], // 信息
      ATableList1: [], // 表格
      ATableData1: [], // 信息
      username: '',
      datenow: '',
      showname: '',
      jfFlag: this.$route.query.jfFlag
    }
  },
  created () {
    // 生命周期里接收参数
    this.id = this.$route.query.id // 接受参数关键代码
    this.username = window.localStorage.getItem('userName')
    this.datenow = dateFormat1(new Date().getTime(), 'CHN-YYYY-MM-ss h-m-s')
    // this.getDictionaryLists()
  },
  mounted () {
    this.printOutstockDocumentLwgS()
  },
  methods: {
    // 打印内容
    printContext () {
      this.$print(this.$refs.print)
    },
    // 点击返回上一步
    back () {
      this.$router.go(-1) // 返回上一层
    },
    // 出库计划-主数据-打印
    printOutstockDocumentLwgS () {
      printOutstockDocumentLwg({
        outstockId: this.id // 出库主表id
      })
        .then((res) => {
          this.ATableList = res.list
          this.ATableData = res.tWhOutstockMaster
          this.weightSum = res.list.reduce((pre, cur) => Number(pre / 1 + cur.allWeight / 1).toFixed(3), 0)
          this.numberSum = res.list.reduce((pre, cur) => pre / 1 + cur.number / 1, 0)
          this.GBweight = res.list.reduce((pre, cur) => Number(pre / 1 + cur.weighingWeight / 1).toFixed(3), 0)
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    }
    // getDictionaryLists () {
    //   getDictionaryList({ tenantCode: window.localStorage.getItem('tenantCode'), groupNo: 'out_empty_remark' })
    //     .then(res => {
    //       console.log(res)
    //       this.showname = res[0].showName
    //     })
    //     .catch(err => {
    //       DonMessage.error(err.message)
    //     })
    // }
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      // let s = date.getSeconds()
      // s = s <script 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m
    }
  }
}
</script>

<style scoped lang='less'>
button {
  width: 100px !important;
}
#printMe {
  font-size: 16px;
  position: relative;
  padding: 10px;
  // margin-bottom: 10px;
  box-sizing: border-box;
  //   height: 500px;
  width: 100%;
  border: 1px solid #ccc;

  .table_title {
    width: 100%;
    height: 40px;
    font-size: 26px;
    text-align: center;
    font-weight: 700;
    margin: 10 0;
  }
}
.printtable{
    width:800px;
    margin-bottom:20px;
  }
.AMarkUl {
  // font-size: 12px !important;
  width: 100%;
  font-size: 14px;
  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
.AMarkFoot {
  font-size: 14px;
  bottom: 10px;
  width: 100%;
  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
table,
th,
td {
  border: 1px solid blue;
}
table {
  border-collapse: collapse;
}

table,
th,
td {
  border: 1px solid black;
}
table {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  font-size: 16px;
  td {
    // width: 17%;
    // padding: 4px 4px;
    text-align: center;
    height: 24px;
  }

  .kunbao {
    font-weight: 600;
  }
}
.remarks{
  font-size:12px;

  p{
    margin:0;
    padding:0;
  }
}
</style>
